module.exports = __webpack_public_path__ + "static/media/biologico.21e13ec1.png";